document.addEventListener('DOMContentLoaded', function () {
  initCustomerReviews();
});

document.addEventListener('shopify:section:load', function (event) {
  initCustomerReviews(event.target);
});

function initCustomerReviews(scope) {
  const sections = [];

  if (scope) {
    if (scope.matches?.('.customer-reviews-cottolio-section')) {
      sections.push(scope);
    } else {
      scope.querySelectorAll('.customer-reviews-cottolio-section').forEach(function (section) {
        sections.push(section);
      });
    }
  } else {
    document.querySelectorAll('.customer-reviews-cottolio-section').forEach(function (section) {
      sections.push(section);
    });
  }

  sections.forEach(function (section) {
    const slider = section.querySelector('.customer-reviews-cottolio__reviews');
    const prevBtn = section.querySelector('.customer-reviews-cottolio__arrow--prev');
    const nextBtn = section.querySelector('.customer-reviews-cottolio__arrow--next');

    if (!slider || typeof Swiper === 'undefined') return;
    if (slider.swiper) slider.swiper.destroy(true, true);

    const showArrows = Boolean(prevBtn || nextBtn);

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 600,
      grabCursor: true,
      watchOverflow: true,
      navigation: showArrows
        ? {
            nextEl: nextBtn,
            prevEl: prevBtn,
          }
        : undefined,
      breakpoints: {
        750: {
          spaceBetween: 24,
        },
      },
    });
  });
}
